export default __webpack_public_path__ + "static/media/hotel_1_hl.0f85f853.png";